import { GridColDef } from "@mui/x-data-grid";
import React from "react";
import ApproveActionCell from "./ApproveActionCell";
import RejectActionCell from "./RejectActionCell";

const columns: GridColDef[] = [
  { field: "datum", headerName: "Datum", flex: 1 },
  { field: "name", headerName: "Name", flex: 1 },
  { field: "suchname", headerName: "Suchname", flex: 1 },
  { field: "feld", headerName: "Feld", width: 100 },
  { field: "wertOriginal", headerName: "Original", flex: 1 },
  { field: "wertAenderung", headerName: "Änderung", flex: 1 },
  {
    field: "status",
    headerName: "Status",
    minWidth: 10,
    cellClassName: (params) => {
      switch (params.value) {
        case "A":
          return "status genehmigt";
        case "P":
          return "status pending";
        case "R":
          return "status abgelehnt";
        default:
          return "";
      }
    },
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 180,
    cellClassName: "actions",
    getActions: ({ id }) => {
      return [<ApproveActionCell id={id} />, <RejectActionCell id={id} />];
    },
  },
];

export default columns;
